import React from 'react'
import PropTypes from 'prop-types'
import { iconsPath } from '@/config/globals'

import styles from './styles.module.scss'

const QuantityInput = ({ itemQuantity, onIncrease, onDecrease, onRemove, dataSelector, disableIncrease = false }) => {
    const decreseSelector = `${dataSelector}_decrese`
    const increseSelector = `${dataSelector}_increse`
    const quantitySelector = `${dataSelector}_quantity`
    const iconRemove = itemQuantity > 1 ? 'icon_remove.svg' : 'icon_trash_can.svg'

    const increaseQuantity = async () => {
        await onIncrease()
    }

    const reduceQuantity = async () => {
        itemQuantity === 1 ? await onRemove() : await onDecrease()
    }

    return (
        <div className={styles.container}>
            <div className={styles.buttonsContainer}>
                <button className={styles.button} onClick={reduceQuantity} data-selector={decreseSelector}>
                    <img src={`${iconsPath}/${iconRemove}`} alt="Remove product" />
                </button>
                <span className={styles.quantity} data-selector={quantitySelector}>{itemQuantity}</span>
                <button className={styles.button} onClick={increaseQuantity} data-selector={increseSelector} disabled={disableIncrease}>
                    <img src={`${iconsPath}/icon_add.svg`} alt="Add more" />
                </button>
            </div>
        </div>
    )
}

QuantityInput.propTypes = {
    itemQuantity: PropTypes.number.isRequired,
    onIncrease: PropTypes.func.isRequired,
    onDecrease: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    dataSelector: PropTypes.string.isRequired,
    disableIncrease: PropTypes.bool
}

export default QuantityInput
